import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../../Base";
import { memo } from "react";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const RemoveWaveErrorAction = memo(({ onCancel }) => {
  const styles = useStyles();

  return (
    <View>
      <Button className={styles.blue} variant={"contained"} onClick={onCancel}>
        Ok
      </Button>
    </View>
  );
});
